var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 35"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uv_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B0BDC5",
    stopOpacity: 0.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#uv_svg__a)",
    d: "M18.49 3C11.56 3 5.54 4.5 2.42 7.48c-6.32 6.85 0 26.6 16.07 26.6s20.22-13.76 19.8-20.4C37.74 5.06 25.41 3 18.48 3z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#2196F3",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.44,
    d: "M13 24.7l11.7-13.18m-5.85 14.55l7.56-8.22m-13.29-.18l5.49-5.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    strokeLinejoin: "round",
    strokeWidth: 0.72,
    d: "M34.35 4.87L38.92 6l-4.43 1.3a.66.66 0 00-.46.47l-1.12 4.48-1.36-4.7a.19.19 0 00-.13-.13l-4.74-1.18 4.8-1.39L32.69 0 34 4.53c.06.17.19.3.36.34"
  })))));
}
export default SvgUv;